import { render, staticRenderFns } from "./SellFactorComponent.vue?vue&type=template&id=2f23fba3&"
import script from "./SellFactorComponent.vue?vue&type=script&lang=js&"
export * from "./SellFactorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports